export default "__VITE_ASSET__CTHsuPZz__"